// Generated types for ExtractionSummaryTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { StepTaskReadAPI, StepTaskWriteAPI } from '../../llm_task/types/steptask';
import { StepTaskReadAPISchemaObject, StepTaskWriteAPISchemaObject } from '../../llm_task/types/steptask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ExtractionSummaryTaskReadAPI extends StepTaskReadAPI {
}

export interface ExtractionSummaryTaskWriteAPI extends StepTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ExtractionSummaryTaskReadAPISchema: z.ZodType<ExtractionSummaryTaskReadAPI> = StepTaskReadAPISchemaObject.extend({}).passthrough();

export const ExtractionSummaryTaskWriteAPISchema: z.ZodType<ExtractionSummaryTaskWriteAPI> = StepTaskWriteAPISchemaObject.extend({}).passthrough();
